export default __webpack_public_path__ + "static/overlay-6b17b178b27a37025769a8ad325b2b0b.png";